<template>
  <div class="csat-container" v-if="!csatSubmitted">
    <div class="csat-container__trigger">
      <h3>O que achou do Check-in?</h3>
      <div class="csat__stars">
        <label v-for="n in 5" :key="n" :for="`ccsat-input-star${n}`" :id="`ccsat-label-star${n}`">
          <span :class="['di', handleStar(n)]"></span>
          <input
            type="radio"
            class="form__radio"
            @click="handleScore($event)"
            :id="`ccsat-input-star${n}`"
            name="star"
            :value="n"
          />
        </label>
      </div>
    </div>
    <div :class="['csat', { '--is-open': csatDisplay }]">
      <div class="csat__content">
        <button id="ccsat-btn-close" class="csat__btn--close" @click="closeCsat()">
          <span class="di di-icon-close"></span>
        </button>
        <div class="form-wrapper" v-if="showForm">
          <h2 class="csat__title">O que achou do Check-in?</h2>
          <form autocomplete="off" class="csat__form" @submit.prevent="handleSubmit($event)">
            <div class="csat__stars">
              <label
                v-for="n in 5"
                :key="n"
                :for="`ccsat-input-star${n}`"
                :id="`ccsat-label-star${n}`"
              >
                <span :class="['di', handleStar(n)]"></span>
                <input
                  type="radio"
                  class="form__radio"
                  @click="handleScore($event)"
                  :id="`ccsat-input-star${n}`"
                  name="star"
                  :value="n"
                />
              </label>
            </div>
            <div class="csat__feedback" v-if="score > 0">
              <p id="ccsat-p-systemresponse">{{ enumScore[score].systemResponse }}</p>
              <label id="ccsat-label-feedbackquestion"
                >{{ enumScore[score].feedbackQuestion }}
              </label>
              <VInput
                label="Deixe um comentário"
                ref="input"
                id="ccsat-input-feedbackansware"
                type="text"
                class="csat__answare"
                v-model="feedbackAnsware"
              />
              <VButton ref="button" id="ccsat-btn-send" text="Avaliar" />
            </div>
          </form>
        </div>
        <div class="csat__submitted" v-else>
          <div class="icon-circle">
            <span class="di di-icon-check"></span>
          </div>
          <h2 class="csat__title">Obrigado por nos avaliar!</h2>

          <p>
            Seu feedback é muito importante e nos ajuda <br />
            melhorar nossa experiencia cada vez mais.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';
import { PaymentTypeClient } from '@/utils/enums/paymentMagicNumberEnum';

export default {
  mixins: [dataLayersMixin],
  data: () => ({
    score: 0,
    showLastFeedback: false,
    feedbackAnsware: '',
    enumScore: {
      5: {
        systemResponse: 'Gostei muito!',
        feedbackQuestion: 'Do que você mais gostou? (Opcional)',
      },
      4: {
        systemResponse: 'Gostei!',
        feedbackQuestion: 'Do que você mais gostou? (Opcional)',
      },
      3: {
        systemResponse: 'Mais ou menos satisfatório.',
        feedbackQuestion: 'O que podemos melhorar? (Opcional)',
      },
      2: {
        systemResponse: 'Não gostei.',
        feedbackQuestion: 'O que aconteceu? (Opcional)',
      },
      1: {
        systemResponse: 'Muito ruim.',
        feedbackQuestion: 'O que aconteceu? (Opcional)',
      },
    },
  }),
  computed: {
    ...mapState({
      csatDisplay: (state) => state.modal.data.csat.display,
      csatSubmitted: (state) => state.modal.data.csat.submitted,
      payment: ({ currentAdmission }) => currentAdmission.data.payments[0],
    }),
    ...mapGetters({
      isT2FlowAllowed: 'global/isT2FlowAllowed',
    }),
    showForm() {
      return !this.csatSubmitted && !this.showLastFeedback;
    },
  },
  methods: {
    ...mapMutations({ setCsatDisplay: 'SET_CSAT_DISPLAY', setCsatSubmitted: 'SET_CSAT_SUBMITTED' }),
    handleScore(event) {
      this.score = Number(event.target.defaultValue);
      this.setCsatDisplay(true);
    },
    closeCsat() {
      this.score = 0;
      this.setCsatDisplay(false);
    },
    handleStar(number) {
      return this.score >= number ? 'di-icon-star-fill' : 'di-icon-star-stroke';
    },
    handleSubmit() {
      // ! --- analytics
      /* eslint-disable */
      dataLayer.push({
        event: 'CSAT',
        score: this.score,
        feedback: this.feedbackAnsware || null,
      });
      /* eslint-enable */
      // analytics --- !
      this.showLastFeedback = true;

      this.mostCommonPagesAnalytics({
        eventType: 'submit',
        step: 'csat',
        screen: 'csat',
        complementaryObject: {
          payment: {
            type: this.payment.clientId === PaymentTypeClient.PRIVATE ? 'particular' : 'convênio',
          },
          csat: {
            score: this.score,
            feedback: this.feedbackAnsware,
          },
        },
      });
      setTimeout(() => {
        this.setCsatDisplay(false);
        setTimeout(() => this.setCsatSubmitted(true), 1000);
      }, 4000);
    },
  },
};
</script>

<style lang="scss">
.csat-container {
  &__trigger {
    margin: 24px 0;
    h3 {
      color: black;
      font-size: 16px;
      line-height: 24px;
      font-family: 'Dasa Sans', sans-serif;
      font-weight: var(--font-weight-bold);
    }
    .csat__stars {
      margin: 12px 0;
      justify-content: center;

      > label {
        margin: 0px 7px;

        input[type='radio'] {
          display: none;
        }
      }

      .di-icon-star-stroke:before {
        font-size: 27px;
      }
    }
  }
}

.csat {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  bottom: -100%;
  z-index: -20;
  opacity: 0;

  transition:
    bottom 0.3s ease,
    z-index 0.2s ease 0.3s,
    opacity 0.2s ease 0.3s;

  &.--is-open {
    bottom: 0%;
    z-index: 99;
    opacity: 1;

    transition:
      bottom 0.3s ease 0.2s,
      z-index 0.2s ease,
      opacity 0.2s ease;
  }
  &__content {
    padding: 24px 0 40px 0;
    border-radius: 7px 7px 0 0;
    width: 100%;
    max-width: 400px;
    position: relative;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-items: space-between; // TODO space-between nao existe?
    align-items: center;
    min-height: 30vh;
  }
  &__title {
    font-size: 20px;
    line-height: 24px;
    font-weight: var(--font-weight-bold);
  }
  .form-wrapper {
    width: 100%;
  }
  &__form {
    padding: 0 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    input[type='radio'] {
      visibility: hidden;
    }
  }
  &__stars {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 19.33px 0;

    > label {
      margin: 0 7px;

      input[type='radio'] {
        display: none;
      }
    }
    .di-icon-star-stroke:before,
    .di-icon-star-fill:before {
      display: block;
      font-size: 27px;
      color: var(--color-primary);
    }
    .di-icon-star-stroke:before {
      color: var(--color-grey-5);
    }
  }
  &__feedback {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      color: var(--color-primary);
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 49px;
    }
    > label {
      width: 100%;
      font-size: 14px;
      line-height: 23.8px;
    }
  }
  &__answare {
    margin: 16px 0;
  }
  &__btn {
    &--close {
      border: none;
      cursor: pointer;
      width: 48px;
      height: 6px;
      font-size: 0px;
      background-color: gray;
      border-radius: 6px;
      margin-bottom: 16px;
    }
  }
  &__submitted {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 40vh;
    .icon-circle {
      background-color: var(--color-success);
      height: 47px;
      width: 47px;
      margin-bottom: 24px;
      .di-icon-check:before {
        font-size: 25px;
        color: #fff;
      }
    }

    > p {
      margin: 16px 0;
      font-size: 14px;
      line-height: 16.41px;
      color: #161616b8;
    }
  }
}
</style>
